import React, { useRef, useEffect } from "react";

export default function ParticipantAudio({ participant }) {
  const audioRef = useRef(null);

  useEffect(() => {
    const el = audioRef.current;
    if (!el || participant.isLocal || !participant.stream) return;

    if (el.srcObject !== participant.stream) {
      el.srcObject = participant.stream;
    }
  }, [participant.stream, participant.isLocal]);

  if (participant.isLocal) return null;

  return (
    <audio
      ref={audioRef}
      autoPlay
      playsInline
      style={{ display: "none" }}
    />
  );
}
